export class CreditCardYearModel {
    public year: string;
    public shortYear: string;
}


// WEBPACK FOOTER //
// ./src/app/_models/credit-card-year.model.ts